import React from "react";
import { Row, Col, Table, FormGroup, Label, Input } from "reactstrap";
import { FormattedDate } from "react-intl";
import MediaQuery from "react-responsive";
import style from "../../../Modal/Invoice/style.module.scss";
import { CustomFormInput } from "../../../../utils/FormFields";
import { formattedNumber } from "../../../FormattedNumber/FormattedNumber";

const SupplierInvoice = ({ invoiceInfo }) => (
  <React.Fragment>
    {" "}
    <CustomFormInput label="Status">{invoiceInfo.SupplierInvoiceStatus}</CustomFormInput>
    <Row>
      <Col>
        <Row xs={12}>
          <Col xs={4}>
            <CustomFormInput label="Supplier">{invoiceInfo.SupplierName}</CustomFormInput>
          </Col>
          <Col xs={2}>
            <CustomFormInput label="Invoice Date">{invoiceInfo.SupplierInvoiceDate}</CustomFormInput>
          </Col>
          <Col xs={2}>
            <CustomFormInput label="Invoice Number">{invoiceInfo.SupplierInvoiceNumber}</CustomFormInput>
          </Col>
          <Col xs={2}>
            <CustomFormInput label="Currency">{invoiceInfo.SupplierInvoiceCurrencyISO}</CustomFormInput>
          </Col>
          <Col xs={2}>
            <CustomFormInput label="Invoice Type">
              {invoiceInfo.SupplierInvoiceTypeDescription}
            </CustomFormInput>
          </Col>
        </Row>
        <Row xs={12}>
          <Col xs={4}>
            <CustomFormInput label="RUT">{invoiceInfo.SupplierRUT}</CustomFormInput>
          </Col>

          <Col xs={2}>
            <CustomFormInput label="Due date">{invoiceInfo.SupplierInvoiceDueDate}</CustomFormInput>
          </Col>
          <Col xs={2}>
            <CustomFormInput label="Invoice Code">{invoiceInfo.SupplierInvoiceCode}</CustomFormInput>
          </Col>
          <Col xs={2}>
            <CustomFormInput label="Payment method">{invoiceInfo.PaymentMethodDescription}</CustomFormInput>
          </Col>
          <Col xs={2}>
            <CustomFormInput label="Invoice associated">
              {invoiceInfo.SupplierInvoiceAssociated}
            </CustomFormInput>
            <CustomFormInput label="Funds">{invoiceInfo.SupplierInvoiceFundId}</CustomFormInput>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row>
      <Details info={invoiceInfo.InvoiceDetails} />
    </Row>
    <Row>
      <Totals i={invoiceInfo} />
    </Row>
    {console.log(invoiceInfo)}
  </React.Fragment>
);

const Details = ({ info }) => (
  <React.Fragment>
    <Table>
      <thead>
        <tr>
          <th style={{ width: "30%" }}>Description</th>
          <th style={{ width: "15%" }}>Concept</th>
          <th style={{ width: "10%" }}>TAX</th>
          <th className="text-center" style={{ width: "13%" }}>
            Subtotal
          </th>
          <th className="text-center" style={{ width: "13%" }}>
            Tax
          </th>
          <th className="text-center" style={{ width: "20%" }}>
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        {info == undefined ? (
          <div></div>
        ) : info.length == 0 ? (
          <div></div>
        ) : (
          info.map(
            (line, index) => (
              console.log(line),
              (
                <tr key={index}>
                  <td td style={{ textAlign: "left" }}>
                    <CustomFormInput label="">{line.InvoiceDetailsDescription}</CustomFormInput>
                  </td>
                  <td td style={{ textAlign: "center" }}>
                    <CustomFormInput label="">{line.ConceptName}</CustomFormInput>
                  </td>
                  <td td style={{ textAlign: "center" }}>
                    <CustomFormInput label="">{line.InvoiceDetailsTAXName}</CustomFormInput>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <CustomFormInput label="">{line.InvoiceDetailsSubtotal}</CustomFormInput>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <CustomFormInput label="">{line.InvoiceDetailsTax}</CustomFormInput>
                  </td>
                  <td td style={{ textAlign: "center" }}>
                    <CustomFormInput label="">{line.InvoiceDetailsTotal}</CustomFormInput>
                  </td>
                </tr>
              )
            )
          )
        )}
      </tbody>
    </Table>
  </React.Fragment>
);

const Totals = ({ i }) => (
  <React.Fragment>
    <div style={{ marginLeft: "20px" }}>
      <CustomFormInput label="Description">{i.SupplierInvoiceDescription}</CustomFormInput>
      <CustomFormInput label="Addendum">{i.SupplierInvoiceAddendum}</CustomFormInput>
    </div>
    <div className={style.totals} style={{ marginRight: "50px" }}>
      <Row className="mx-3">
        <CustomFormInput label="Sub Total">
          {formattedNumber(i.SupplierInvoiceSubtotal, "currency")}
        </CustomFormInput>
      </Row>
      <Row className="mx-3">
        <CustomFormInput label="Tax">{formattedNumber(i.SupplierInvoiceTax, "currency")}</CustomFormInput>
      </Row>
      <Row className="mx-3">
        <CustomFormInput label="Total">{formattedNumber(i.SupplierInvoiceTotal, "currency")}</CustomFormInput>
      </Row>
    </div>
  </React.Fragment>
);
export default SupplierInvoice;
